import { Col, Container, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { IoIosCloseCircle } from "react-icons/io";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import FormPatient from "../components/patient/FormPatient";
import FormPatientColombia from "../components/patient/FormPatientColombia";
import useCompanyType from "../hook/useCompanyType";

function EditFormPacientes({t}){
    const {id} = useParams()
    const companyType = useCompanyType()

    return (
        <Container fluid className="my-5">
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">{`${id ? t('editar') : t('agregar')} ${t('paciente')}`}</h2>
                </Col>
                <Col xs="12" md="4" className="text-right">
                    <Link to="/admin/doctors/patients"><IoIosCloseCircle className="cancel-btn"/></Link>                    
                </Col>
            </Row>
            {
                companyType === "colombia" ? 
                <FormPatientColombia id={id} edit={true} isNew={true} /> :
                <FormPatient id={id} edit={true} isNew={false}/>            
            }            
        </Container>
    )
}

export default withTranslation()(EditFormPacientes)